import { useEffect, useState } from "react";

export const useManagedFilesToBeUploaded = (acceptedFiles: readonly File[]) => {
  const [files, setFiles] = useState<File[]>([]);

  const removeFile = (fromFile: File) => {
    setFiles(files.filter((file) => file.name !== fromFile.name));
  };

  useEffect(() => {
    setFiles((state) => {
      const combined = [...state, ...acceptedFiles];
      const seen = new Set<string>();
      return combined.filter((file) => {
        if (seen.has(file.name)) return false;
        seen.add(file.name);
        return true;
      });
    });
  }, [acceptedFiles]);

  return { files, removeFile };
};
